import React from "react";
import styles from "./home.module.css";
import NavBar from "../../components/NavBar/NavBar";
import HeroSection from "../../components/heroSection/heroSection";
import Card from "../../components/cardHero/cardHero";
import bankIcon from "../../assets/images/bank-line.svg";
import chargingIcon from "../../assets/images/charging-pile-line.svg";
import navigatingIcon from "../../assets/images/Vector.svg";
import Footer from "../../components/footer/footer";
import Divisions from "../../components/divisions/division";
import Verticals from "../ourVerticals/index";
import OurStory from "../../components/ourStory/index";
const home = () => {
  return (
    <div>
      <NavBar />
      <HeroSection />
      <OurStory />
      <Verticals />

      <Footer />
    </div>
  );
};

export default home;
